import { pricesByCurrencies } from "@components/_subscription/helpers/constants"
import { useAccount } from "./use-account"
import { useCurrency } from "./use-currency"

export type PlanType = "FREE" | "BASIC" | "BUSINESS" | "ENTERPRISE"
export type UsePlanData = {
  type: PlanType
  name: string
  description: string
  isCancelled: boolean
  isDowngradedFromBusiness: boolean
  periodEnd?: Date
  autoTopUpEnabled: boolean
  topUpPrice: number | null
  topUpCreditsAmount: number | null
  monthlyCreditsAmount: number | null
}
export type UsePlanPayload = {
  data?: UsePlanData
}

export const usePlan = (): UsePlanPayload => {
  const account = useAccount()
  let data: UsePlanData | undefined = undefined
  // const currency = "USD"
  const { currency } = useCurrency()
  if (account && account.AccountSubscription?.Plan) {
    const { Plan } = account.AccountSubscription
    const { stripeSubscription } = account

    let type: PlanType = "FREE"
    let description = ""
    let isDowngradedFromBusiness = false

    if (Plan.name.includes("BASIC")) {
      type = "BASIC"
      description = `${pricesByCurrencies[currency].symbol}${pricesByCurrencies[currency].prices.Basic.main.toFixed(2)} · ${Plan.monthlyCreditsAmount} credits /month`
    }

    if (Plan.name.includes("BUSINESS")) {
      type = "BUSINESS"
      description = `${pricesByCurrencies[currency].symbol}${pricesByCurrencies[currency].prices.Business.main.toFixed(2)} · ${Plan.monthlyCreditsAmount} credits /month`
      // Currently subscription only have schedule when downgrading from business to basic
      isDowngradedFromBusiness = Boolean(stripeSubscription?.schedule)
    }

    if (Plan.name.includes("ENTERPRISE")) {
      type = "ENTERPRISE"
    }

    data = {
      isCancelled: stripeSubscription
        ? stripeSubscription.cancel_at_period_end
        : false,
      isDowngradedFromBusiness,
      periodEnd: stripeSubscription
        ? new Date(stripeSubscription.current_period_end * 1000)
        : undefined,
      name: Plan.name,
      description,
      type,
      autoTopUpEnabled: account.AccountSubscription.autoTopUpEnabled,
      topUpPrice: Plan.topUpPrice,
      topUpCreditsAmount: Plan.topupCreditsAmount,
      monthlyCreditsAmount: Plan.monthlyCreditsAmount,
    }
  }

  return {
    data,
  }
}
